import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { CalendarTable } from '@/components/calendar-table';

export const Route = createFileRoute(
    '/_auth/dashboard/organizations/$organizationId/planning/',
)({
    component: RouteComponent,
});

function RouteComponent() {
    const { organizationId } = Route.useParams();
    const { t } = useTranslation('dashboard');
    return (
        <div className="flex flex-col max-sm:flex-wrap gap-8 justify-start">
            <div className="flex justify-between">
                <div className="flex flex-col gap-1">
                    <h3 className="text-2xl font-semibold">
                        {t('dashboard.planning.title')}
                    </h3>
                    <p className="text-md text-text-primary/70">
                        {t('dashboard.planning.subtitle')}
                    </p>
                </div>
            </div>
            <CalendarTable.Header organizationId={organizationId} />
        </div>
    );
}
